import { PaymentApi, PaymentTransactionEntry } from '../../../services';
import { redirectOnCancelPayment } from '../../../services/utils';
import LibUrl from './2c2p.config';

export default {
  authorizePaymentWithComponent(
    entry?: PaymentTransactionEntry,
    paymentId = '',
    transactionID = '',
    refType = '',
    closeModal = false,
    redirectUrl = '',
  ): Promise<void> {
    const config = ConfigService.getConfigs();
    const baseUrl = config.NEXT_PUBLIC_2C2P_BASE_URL;
    return new Promise((resolve, reject) => {
      if (!entry?.payload?.webPaymentUrl) {
        reject(new Error('Initiate entry data not found'));
      } else {
        const webPaymentUrl = entry?.payload?.webPaymentUrl;
        const container = document.createElement('div');
        container.setAttribute('id', 'pgw-ui-container');
        document.body.appendChild(container);
        const script = document.createElement('script');
        script.src = baseUrl + LibUrl.JS_URL;
        const link = document.createElement('link');
        // const fontLink = document.createElement('link');
        link.href = baseUrl + LibUrl.CSS_URL;
        link.rel = 'stylesheet';
        // fontLink.rel = 'stylesheet';
        // fontLink.href = LibUrl.FONT_URL;
        script.async = true;
        // document.head.appendChild(fontLink);
        document.head.appendChild(link);
        document.head.appendChild(script);

        script.onload = () => {
          const uiRequestFull = {
            url: webPaymentUrl,
            // templateId: 'amwaycheckout', //template id provide 2c2p
            mode: 'Dialog',
            appBar: true,
            cancelConfirmation: true,
            container: {
              width: '500px', //or 80%
              height: '800px', // or 80%
              style: 'border: 2px solid grey;',
            },
          };

          //PGWSDK eslint issue
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          //@ts-ignore eslint-disable-next-line
          PGWSDK.paymentUI(uiRequestFull, function (response) {
            // TODO 2c2p not provide callback yet.
            // resolve after get callback, and return feedback cancel or success
            // console.log('cancel 2c2p response', response);
            if (response.responseCode == '0003') {
              PaymentApi.cancelPayment(paymentId, transactionID).then((data) => {
                redirectOnCancelPayment(data, refType, closeModal, redirectUrl);
              });
            }
          });
          resolve();
        };
        script.onerror = () => {
          reject(new Error('Script loading failed'));
        };
      }
    });
  },
};
